import { render, staticRenderFns } from "./SendForgotSuccess.vue?vue&type=template&id=7d33a1c8&scoped=true&"
import script from "./SendForgotSuccess.vue?vue&type=script&lang=js&"
export * from "./SendForgotSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d33a1c8",
  null
  
)

export default component.exports